<div class="p-4">
  <app-image-slider></app-image-slider>
  <h2><strong>Prescripción:</strong> Paso {{progressStepper}} de 9</h2>
  <div class="progress">
    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': getProgressBarPercentage()}" attr.aria-valuenow="{{progressStepper}}" aria-valuemin="0" aria-valuemax="9">{{progressStepper}}</div>
  </div>
</div>
<mat-horizontal-stepper hide-header #stepper [linear]="false" (selectionChange)="onChangeStepper($event)" class="w-100 h-100 bg-transparent">
  <mat-step label="Paso 1" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-first-step [prescriptionData]="prescriptionStep1Data" (setupTypeChange)="onSetupTypeChange($event)"></app-client-first-step>
  </mat-step>
  <mat-step label="Paso 2" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-second-step [prescriptionData]="prescriptionStep2Data"></app-client-second-step>
  </mat-step>
  <mat-step label="Paso 3" [stepControl]="" *ngIf="setupType==0 || setupType==1" class="h-100 w-100 m-0 p-0">
    <app-client-third-step [prescriptionData]="prescriptionStep3Data"></app-client-third-step>
  </mat-step>
  <mat-step label="Paso 4" [stepControl]="" *ngIf="setupType==0 || setupType==2" class="h-100 w-100 m-0 p-0">
    <app-client-fourth-step [prescriptionData]="prescriptionStep4Data"></app-client-fourth-step>
  </mat-step>
  <mat-step label="Paso 5" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-fifth-step [prescriptionData]="prescriptionStep5Data"></app-client-fifth-step>
  </mat-step>
  <mat-step label="Paso 6" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-sixth-step [prescriptionData]="prescriptionStep6Data"></app-client-sixth-step>
  </mat-step>
  <mat-step label="Paso 7" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-seventh-step [prescriptionData]="prescriptionStep7Data"></app-client-seventh-step>
  </mat-step>
  <mat-step label="Paso 8" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-eighth-step  [prescriptionData]="prescriptionStep8Data"></app-client-eighth-step>
  </mat-step>
  <mat-step label="Paso 9" [stepControl]="" class="h-100 w-100 m-0 p-0">
    <app-client-nineth-step [prescriptionData]="prescriptionStep9Data"></app-client-nineth-step>
  </mat-step>
</mat-horizontal-stepper>
